import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchFullConfig, forkCase, submitSweep } from "./api";
import type { ForkRequest, SweepRequest } from "./types";

export function useFullConfig(caseId: string | null) {
  return useQuery({
    queryKey: ["flow360-full-config", caseId],
    queryFn: () => fetchFullConfig(caseId!),
    enabled: !!caseId,
    staleTime: 5 * 60_000,
  });
}

export function useForkCase(onSuccess?: () => void) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: ForkRequest) => forkCase(req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["provenance"] });
      qc.invalidateQueries({ queryKey: ["run-table"] });
      onSuccess?.();
    },
  });
}

export function useSweep(onSuccess?: () => void) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: SweepRequest) => submitSweep(req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["provenance"] });
      qc.invalidateQueries({ queryKey: ["run-table"] });
      onSuccess?.();
    },
  });
}
